module.exports = __webpack_public_path__ + "static/media/Android-app-on-google-play.fd2dfcc4.png";